import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { IEditIframePayload } from "@app/dashboard/types/innerLayout/iframes/edit-iframe";

export const editIframe = (iframeId: number, payload: IEditIframePayload) => {
  return axiosPrivate.put(`/dashboard/api/v1/iframes/${iframeId}`, payload);
};